import { render, staticRenderFns } from "./PaymentsSelect.vue?vue&type=template&id=81d571fe"
import script from "./PaymentsSelect.vue?vue&type=script&lang=js"
export * from "./PaymentsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports